
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
      default: "Marital Status",
    },
    formProp: {
      type: String,
      required: true,
      default: "marital_status",
    },
    modelValue: {
      type: String,
      required: true,
      default: "",
    },
    placeHolder: {
      type: String,
      required: false,
      default: "",
    },
    tooltipMessage: {
      type: String,
      required: false,
      default: "",
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTooltip: {
      type: Boolean,
      required: false,
      default: false,
    },
    dropdown: {
      type: Array,
      required: false,
      default: null,
    },
  },

  setup(_, context) {

    const updateValue = (event) => {
      context.emit("update:modelValue", event);
      context.emit("change", event);
    };

    const marital_status = ref()
    const focus = () => {
      setTimeout(() => {
        marital_status.value.focus()
      }, 500);
    }

    return {
      marital_status,
      focus,
      updateValue,
    };
  },
});
